var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrontTooth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1.54734in",
    height: "0.553386in",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 283 101",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .b0 {stroke:#999999;stroke-width:1.2688}\n    .bf0 {fill:none}\n   "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2974850395328"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bf0 b0",
    d: "M95 49c0,2 1,4 1,5 1,2 2,3 3,4 5,3 36,3 39,1 3,-1 2,-5 3,-7 0,-14 -2,-29 -10,-40 -3,-4 -4,-4 -7,-7 -1,-2 -3,-3 -6,-4 -1,0 -3,-1 -5,0 -4,1 -6,3 -8,6 -7,9 -11,31 -10,42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf0 b0",
    d: "M188 50c1,-5 -1,-19 -2,-24 -2,-7 -4,-14 -8,-19 -1,-1 -2,-2 -3,-3 0,-1 -1,-1 -1,-1l-3 -2c-4,-1 -9,1 -12,4 -1,0 -1,1 -2,1l-7 8c0,1 0,1 0,1 -3,5 -2,4 -5,9 -2,8 -4,19 -3,27 0,2 0,7 2,8 0,0 2,1 2,1 7,1 31,1 37,-2 1,0 3,-2 3,-3 1,-1 2,-3 2,-5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf0 b0",
    d: "M243 40c1,-5 -1,-30 -6,-32 -2,-1 -5,2 -7,4 -1,1 -1,1 -1,1 -1,1 -1,2 -2,3 -1,1 -2,1 -2,2 -2,2 -4,4 -6,9 -1,4 -2,13 -1,17 1,2 3,5 3,6l2 3c0,0 0,0 0,0 3,3 3,3 6,5 3,1 8,-2 9,-4 2,-1 3,-3 4,-6 0,-2 1,-5 1,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf0 b0",
    d: "M216 42c1,-6 0,-12 -1,-17 -1,-4 -3,-10 -5,-13 -2,-3 -5,-1 -8,1 -3,2 -3,3 -5,5 -2,2 -4,7 -4,9 -2,4 -4,20 -3,24 0,1 0,2 1,3 1,0 2,1 3,1 4,1 14,1 17,-1 1,-1 1,-1 2,-2 2,-3 2,-6 3,-10z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf0 b0",
    d: "M67 40c0,3 1,7 2,10l0 1c0,0 0,0 0,1 3,5 19,4 22,2 4,-2 2,-6 2,-10 0,-9 -3,-21 -8,-28 -2,-2 -8,-7 -11,-5 -3,2 -5,8 -6,13 -1,6 -1,10 -1,16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf0 b0",
    d: "M40 40c0,4 1,8 2,11l3 3c0,1 0,1 1,2 4,2 7,5 13,-3l2 -2c1,-2 3,-4 3,-7 2,-5 1,-14 -2,-20l-7 -9c-3,-3 -2,-4 -6,-6 -5,-3 -6,1 -7,5 -1,8 -3,19 -2,26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf0 b0",
    d: "M56 58c0,8 1,30 4,38 3,8 7,4 10,-1 6,-9 7,-14 9,-26 1,-7 0,-7 0,-12 -5,-1 -6,-1 -9,-3 -3,-3 -2,-4 -3,-4 -4,-2 -6,3 -6,3 0,1 -1,0 -1,1 -2,3 -1,2 -4,4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf0 b0",
    d: "M203 57c1,5 0,5 1,12 2,9 2,14 6,22 1,1 1,1 2,2 1,3 3,6 6,7 9,4 9,-39 9,-42 -1,-1 -1,-1 -2,-1 -1,-1 -2,-3 -3,-4 -1,-1 -1,-2 -2,-3 -1,0 -3,-1 -4,0 -1,0 -1,1 -2,2 -2,4 -5,4 -11,5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf0 b0",
    d: "M81 57c0,1 0,4 1,5 1,7 3,21 6,27 1,2 1,3 2,4 1,1 3,3 4,4 3,2 8,-5 9,-7 0,-1 0,-2 1,-2 0,-1 0,-2 1,-3 1,-4 2,-8 3,-13 1,-3 2,-7 2,-11 -4,-1 -7,0 -10,-2 -3,-1 -5,-4 -5,-5 0,0 -2,0 -2,0 -2,3 -9,3 -12,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf0 b0",
    d: "M173 64c0,0 3,20 9,29 5,6 8,4 11,-1l2 -4c2,-4 7,-27 7,-31 -3,0 -5,0 -8,-1 -5,-1 -1,-2 -6,-2 -1,1 -2,3 -3,4 0,0 0,0 -1,1l-3 1c-2,1 -4,1 -6,1 -3,0 -2,0 -2,3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf0 b0",
    d: "M111 61c-1,3 2,22 5,27 0,1 1,2 1,2 0,1 1,2 1,2 2,2 5,5 9,3 8,-4 10,-20 12,-27 0,-2 2,-7 2,-10 -2,4 -8,3 -14,3 -3,0 -6,0 -8,0l-8 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf0 b0",
    d: "M164 61c-5,1 -12,0 -17,0 -2,0 -4,-1 -5,-3 0,3 1,8 2,10 1,4 2,7 3,11 1,3 2,8 4,10l0 1c1,1 1,1 2,2 1,1 2,2 3,3 4,2 7,-1 9,-3 1,-2 3,-5 4,-8 1,-6 3,-17 3,-23l-8 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf0 b0",
    d: "M41 50c-2,0 -1,1 -4,5l-2 4c-2,2 -3,1 -3,4 -2,8 -2,14 -2,21 0,3 1,10 3,12l1 0c1,0 4,-1 5,-2 2,-2 3,-2 5,-4l1 -3c1,-1 1,-1 2,-2 0,0 0,-1 0,-1 3,-5 4,-9 6,-13 1,-5 1,-8 2,-13 -5,3 -12,-2 -14,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf0 b0",
    d: "M228 58c3,16 3,19 12,33 1,1 2,2 3,2 1,2 1,1 3,3 1,0 2,0 3,0l2 -1c0,0 0,-1 0,-1l1 -3c1,-5 0,-22 -1,-28 0,-3 -1,-2 -3,-4l-3 -4c-2,-4 -1,-5 -3,-5 -2,6 -9,11 -14,8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf0 b0",
    d: "M18 37c0,10 1,22 7,25 3,1 5,-1 6,-2 6,-6 8,-6 8,-17 0,-3 -3,-9 -5,-11l-2 -4c-1,0 -1,0 -1,-1 -1,-1 -2,-2 -2,-2 -1,-1 0,0 -1,-1 0,-1 -1,-1 -1,-1 -1,-1 -3,-3 -5,-4 -2,-1 -3,0 -4,3 -1,3 0,11 0,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf0 b0",
    d: "M265 36c0,-4 1,-12 -1,-15 -2,-4 -6,0 -7,0 0,1 0,1 0,1l-3 3c-1,0 0,-1 -1,1 -1,1 -4,4 -5,6 -3,5 -6,16 -3,21l8 8c1,1 1,1 2,1 2,1 5,-2 6,-4 1,0 1,-1 1,-1 2,-4 3,-16 3,-21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf0 b0",
    d: "M278 49c1,-4 1,-21 -1,-24 -1,-2 -3,1 -4,2 -5,7 -11,24 -5,31 1,1 1,2 3,2 2,-1 3,-2 4,-3 3,-3 3,-3 3,-8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf0 b0",
    d: "M6 25c0,0 -1,1 -1,2 -1,2 -1,18 -1,20 0,2 1,4 1,5 1,3 2,4 4,6 0,0 1,1 1,1 4,2 8,-3 7,-10 0,-6 -2,-13 -5,-18l-3 -5c-1,-1 -2,-2 -3,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf0 b0",
    d: "M252 62c1,2 1,5 2,8 1,3 2,5 3,7 1,4 6,11 10,10 3,-1 1,-22 0,-27 0,-1 -2,-6 -3,-7 0,1 -1,4 -2,5l-1 3c-3,3 -6,3 -9,1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf0 b0",
    d: "M18 53c0,1 0,3 -1,4 -1,3 -2,9 -2,13 0,3 -2,17 1,17 2,1 4,-1 5,-2 7,-7 7,-15 10,-23 -3,2 -7,1 -10,-2 0,0 0,0 0,0 -1,-2 -3,-5 -3,-7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf0 b0",
    d: "M268 59c1,5 1,10 4,16 1,1 1,2 2,3 0,0 0,0 0,0l1 1c0,1 1,1 2,2 2,1 4,2 5,-2 0,-1 0,-2 0,-3 0,-2 -1,-4 -1,-7 -2,-4 -3,-8 -5,-12 0,1 -1,2 -1,2 -3,2 -5,2 -7,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf0 b0",
    d: "M7 57c-2,4 -6,16 -6,20 0,8 6,5 9,-1 1,-1 1,-2 2,-3 1,-6 2,-11 3,-14 -1,1 -3,2 -5,1 -1,0 -3,-2 -3,-3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontTooth);
export default __webpack_public_path__ + "static/media/FrontTooth.228959b28bc6c88ddc4c5cb7599e595c.svg";
export { ForwardRef as ReactComponent };